import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SubTitle from "../../components/SubTitle/SubTitle";
import SkeletonLoad from "../../components/Skeleton/SkeletonLoad";
import { DeleteOutlined } from "@ant-design/icons";
import { getLog } from "../../redux/actions/log.action";
import { loadJobTitle } from "../../redux/actions/salePerson/jobTitle.action";
import { loadReportCurrency } from "../../redux/actions/salePerson/reportCurrency.action";
import { loadSupervisor } from "../../redux/actions/salePerson/supervisor.action";
import { getRights } from "../../redux/actions/userRights.action";
import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { addVendor, deleteVendor, getOneVendor, getVendors, updateVendor } from "../../redux/actions/vendor.action"
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input, Tabs, Tooltip, Divider, Select, Checkbox, Radio, InputNumber, Popconfirm, Tag, Collapse, Modal, Upload, Table, Space, message } from "antd";
import { CloseCircleOutlined, UndoOutlined, UploadOutlined, EyeOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { getAllCompany } from "../../redux/actions/companyAccess";
import { logColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import { ReadCookie } from "../../utils/readCookie";

import "../Style/style.css";
import "./vendor.css";

import "../Product/product.css";
import VendorShipping from "./vendorShipping";
import VendorBilling from "./vendorBilling";

import { addVendorBank, addVendorBiller, deleteVendorBank, deleteVendorBiller, getAllVendorBank, getVendorBilling, updateVendorBank, updateVendorBiller } from "../../redux/actions/vendor_bill.action";
import { addVendorShipper, deleteVendorShipper, getVendorShipping, updateVendorShipper } from "../../redux/actions/vendor_ship.action";
import { TabTitle } from "../../utils/GeneralFunction"
import { getVendorCategory } from "../../redux/actions/vendorCategory.action";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import { BASEURL } from "../../constant/config";
import Swal from "sweetalert2";
import moment from "moment";
import Loader from "react-loader-spinner";
import { getSystemLog } from "../../redux/actions/systemLog.action";
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;
const { TextArea } = Input;

export default function Vendor({ token }) {
    TabTitle("Vendor")

    const vendorInput = useRef(null);
    const [form] = Form.useForm();
    const [submit, setSubmit] = useState(false);
    const submitButton = useRef(null);
    const [rights, setRights] = useState(false);
    const [salePersonAllId, setSalepersonAllId] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const { log, companyAll, userRights, salePersonForm, vendor, vendorCategory, systemLog } = useSelector((state) => state);
    // Primary Info
    const focusInput = useRef(null);
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState("view");
    const menuId = ReadCookie("menuId");
    const [companyId, setCompanyId] = useState(ReadCookie("defaultCompany"));
    const [disable, setDisable] = useState(false);
    const [salepersonGridView, setSalePersonGridView] = useState(false);

    const [filteredInfo, setFilteredInfo] = useState(null);
    const [sortedInfo, setSortedInfo] = useState(null);
    const [dataLen, setDataLen] = useState(0);
    const [show, setShow] = useState(false);
    const [typeValue, setTypeValue] = React.useState("I");
    const [addressDataBill, setAddressDataBill] = useState([]);
    const [addressDataShip, setAddressDataShip] = useState([]);
    const [customerID, setCustomerId] = useState("");
    const [check, setCheck] = useState(true);

    const [deletedBillItems, setDeletedBillItems] = useState([]);
    const [deletedShipItems, setDeletedShipItems] = useState([]);

    const [loading, setloading] = useState(false);


    // Bank
    const [bankmodalForm] = Form.useForm();
    const [bankList, setBankList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null); // Track if editing existing item
    const [bankListDeleted, setBankListDeleted] = useState([]);

    console.log("bankList==>", bankList)



    // Communication Tab
    const [isFileModalVisible, setIsFileModalVisible] = useState(false);
    const [fileloading, setFileLoading] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [communucationFile, setCommunicationFile] = useState([]);
    const [modalForm] = Form.useForm();
    const [selectedFileType, setSelectedFileType] = useState("");


    console.log("addressDataBill", addressDataBill)
    const queryParams = new URLSearchParams(window.location.search);
    const vendor_id = queryParams.get("vendor_id");

    useLayoutEffect(() => {
        if (menuId) {
            dispatch(getRights(token, menuId)).then((res) => {
                if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                    console.log("RUNNING")
                    if (!res?.payload.can_add) {
                        setFormState("table");
                    }
                }
            });
        }

    }, []);



    useEffect(() => {
        if (companyId) {
            setCompanyId(parseInt(companyId));
            form.setFieldsValue({
                company: companyId,
            });
        }
        dispatch(getAllCompany(token));
    }, [companyId]);

    useEffect(() => {
        dispatch(loadSupervisor(token));
        dispatch(loadJobTitle(token));
        dispatch(loadReportCurrency(token));
        dispatch(getVendorCategory(token));

    }, [token]);

    const renderColumns = () => {
        const keys = Object.keys(systemLog?.payload?.data[0]);
        return keys.map((it, i) => {
            return {
                title: it,
                dataIndex: it,
                key: i.toString(),
            };
        });
    };



    const onTypeChange = e => {

        setTypeValue(e.target.value);
    };


    const getAllFiles = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: `${BASEURL}getAll/vendorCommunication`,
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + token,
                },
                data: { vendor_id: vendor_id },

            });

            console.log("getAllFiles response:", response);

            if (response?.data) {

                const dataArray = Array.isArray(response.data)
                    ? response.data
                    : response.data?.data || [];

                setCommunicationFile(dataArray);
            }
        } catch (error) {
            console.error("Error fetching files:", error);
        }
    }

    useEffect(() => {
        if (vendor_id) {
            setloading(true);
            setFormState("formView");
            dispatch(getOneVendor(token, vendor_id)).then((vendor) => {

                if (vendor.type === "GET_ONE_VENDOR_SUCCESS") {
                    form.setFieldsValue({
                        company: vendor?.payload?.data[0].company_id,
                        vendorID: vendor?.payload?.data[0].vendor_id,
                        vendorName: vendor?.payload?.data[0].vendor_name,
                        vendorType: vendor?.payload?.data[0].vendor_type,
                        vendorCode: vendor?.payload?.data[0].vendor_code,
                        webaddress: vendor?.payload?.data[0].web_address,
                        balance: vendor?.payload?.data[0].balance,
                        email: vendor?.payload?.data[0].email_address,
                        vendorCat: vendor?.payload?.data[0].vendor_category_id,
                        fax: vendor?.payload?.data[0].fax,
                        mobilePhone: vendor?.payload?.data[0].mobile,
                        officePhone: vendor?.payload?.data[0].office,
                        // active: vendor?.payload?.data[0].is_active,
                    });
                    setCustomerId(vendor?.payload?.data[0].vendor_id);
                    setCheck(vendor?.payload?.data[0].is_active);
                    setloading(false);


                }

            });
            getAllFiles();
        } else {
        }
    }, [salePersonAllId]);



    const onSearch = (val) => {

    };

    const handleTab = (key) => {

        if (key === "shipping") {
            if (formState === "formView" || formState === "edit") {
                dispatch(getVendorShipping(token, vendor_id));
            }
        }

        if (key === "billing") {
            if (formState === "formView" || formState === "edit") {
                dispatch(getVendorBilling(token, vendor_id));
            }
        }
        if (key === "logs") {
            dispatch(getSystemLog(token, { table_name: "scm_vendor", record_id: vendor_id }));
        }
        if (key === "bank") {
            if (formState === "formView" || formState === "edit") {
                dispatch(getAllVendorBank(token, { vendor_id: vendor_id })).then((res) => {
                    console.log("Res", res);
                    if (res?.type === "GET_ALL_VENDOR_BANK_SUCCESS") {
                        setBankList(res?.payload?.data);
                    }

                })
            }
        }

    };

    useEffect(() => {
        if (formState === "view" || formState === "table" || formState === "add") {

            form.setFieldsValue({
                company: companyId,
                vendorID: null,
                vendorName: null,
                vendorType: null,
                vendorCode: null,
                webaddress: null,
                balance: null,
                vendorCat: null,
                officePhone: null,
                mobilePhone: null,
                active: false,
                fax: null,
                email: null,

            });

            setBankList([]);
            setBankListDeleted([]);

        }
    }, [formState]);

    const formSave = () => {
        setSubmit(true);
        submitButton.current.click();
    };

    const onFinish = async (e) => {
        setSubmit(false);
        setloading(true);

        // Safely handle event object if passed
        if (e?.target?.name) {
            form.setFieldsValue({ [e.target.name]: e.target.value });
        }

        try {
            const values = await form.validateFields();

            // ================= CREATE / ADD VENDOR =================
            if (formState === "add") {
                const res = await dispatch(addVendor(token, values, check));

                if (res.type === "ADD_VENDOR_ERROR") {
                    notification(
                        "error",
                        res?.payload?.request?.statusText || "Error",
                        res?.payload?.data?.data || "Failed to create vendor"
                    );
                    setloading(false);
                    return;
                }

                if (res.type === "ADD_VENDOR_SUCCESS") {
                    const vendorId = res?.payload?.vendor_id;

                    // Clone array to avoid directly mutating state
                    if (addressDataBill.length > 0) {
                        const billingItems = addressDataBill.map(({ key, ...rest }) => ({
                            ...rest,
                            vendor_id: vendorId,
                        }));
                        await dispatch(addVendorBiller(token, billingItems, vendorId));
                    }

                    if (addressDataShip.length > 0) {
                        const shippingItems = addressDataShip.map(({ key, ...rest }) => ({
                            ...rest,
                            vendor_id: vendorId,
                        }));
                        await dispatch(addVendorShipper(token, shippingItems, vendorId));
                    }
                    if (bankList.length > 0) {
                        const bankItems = bankList.map(({ key, ...rest }) => ({
                            ...rest,
                            vendor_id: vendorId,
                        }));
                        await dispatch(addVendorBank(token, bankItems, vendorId));
                    }

                    notification("success", "Vendor Created", "Vendor created successfully!");

                    // form.resetFields(); // Replaces manual null assignments
                    // form.setFieldsValue({ company: companyId, active: false });

                    setFormState("formView");
                    setloading(false);
                    history.push(`/vendor?mode=edit&vendor_id=${vendorId}`);
                }
            }

            // ================= EDIT / UPDATE VENDOR =================
            if (formState === "edit") {
                const res = await dispatch(updateVendor(token, values, vendor_id));

                if (res.type === "UPDATE_VENDOR_ERROR") {
                    notification("error", "Update", "Something went wrong");
                    setloading(false);
                    return;
                }

                if (res.type === "UPDATE_VENDOR_SUCCESS") {
                    const promises = [];

                    // Update Billing
                    if (addressDataBill.length > 0) {
                        const items = addressDataBill.map(({ key, ...rest }) => ({
                            ...rest,
                            vendor_id: Number(vendor_id),
                        }));

                        await dispatch(updateVendorBiller(token, items, vendor_id)).then(async (res) => {
                            if (res.type === "UPDATE_VENDOR_BILLING_SUCCESS") {
                                const result = await dispatch(getVendorBilling(token, vendor_id));
                                if (result.type === "GET_VENDOR_BILLING_SUCCESS") {
                                    setAddressDataBill(result?.payload?.data);
                                }
                            }
                        });
                        // promises.push(billPromise);
                    }

                    // Delete Billing Items
                    if (deletedBillItems.length > 0) {
                        await dispatch(deleteVendorBiller(token, vendor_id, deletedBillItems));
                    }

                    // Delete Shipping Items
                    if (deletedShipItems.length > 0) {
                        await dispatch(deleteVendorShipper(token, vendor_id, deletedShipItems));
                    }

                    if (bankListDeleted.length > 0) {
                        await dispatch(deleteVendorBank(token, bankListDeleted));
                    }

                    if (bankList.length > 0) {
                        const bankItems = bankList.map(({ key, ...rest }) => ({
                            ...rest,
                            vendor_id: vendor_id,
                        }));
                        await dispatch(updateVendorBank(token, bankItems, vendor_id));
                    }

                    // Update Shipping
                    if (addressDataShip.length > 0) {
                        const itemsShip = addressDataShip.map(({ key, ...rest }) => ({
                            ...rest,
                            vendor_id: Number(vendor_id),
                        }));

                        await dispatch(updateVendorShipper(token, itemsShip, vendor_id)).then(async (res) => {
                            if (res.type === "UPDATE_VENDOR_SHIPPING_SUCCESS") {
                                const result = await dispatch(getVendorShipping(token, vendor_id));
                                if (result.type === "GET_VENDOR_SHIPPING_SUCCESS") {
                                    setAddressDataShip(result?.payload?.data);
                                }
                            }
                        });
                        // promises.push(shipPromise);
                    }

                    // Wait for all sub-operations to finish before updating UI
                    // await Promise.all(promises);

                    notification("success", "Vendor Updated", "Vendor updated successfully");
                    setFormState("formView");
                    setSalepersonAllId(null);
                    setloading(false);
                }
            }
        } catch (error) {
            // Form validation errors or unhandled exceptions
            console.error("Form submit error:", error);
            setloading(false);
        }
    };



    const handleDelete = () => {
        console.log("form", form.getFieldValue());
        dispatch(deleteVendor(token, form.getFieldValue().vendorID)).then((res) => {
            if (res.type === "DELETE_VENDOR_SUCCESS") {
                notification(
                    "success",
                    "Vendor Deleted",
                    "Vendor deleted successfully!"
                );
                form.setFieldsValue({
                    company: companyId,
                    employee_id: null,
                    empName: null,
                    jobTitle: null,
                    SuperVisor: null,
                    reportingCurrency: null,
                    hireDate: null,
                    email: null,
                    officePhone: null,
                    mobilePhone: null,
                    homePhone: null,
                    fax: null,
                });
                history.push("/vendor-info/getAll");
            }
            if (res.type === "DELETE_VENDOR_ERROR") {
                notification(
                    "error",
                    res?.payload?.request?.statusText,
                    res?.payload?.data?.data
                );
            }
        });
    };





    const filterReset = () => {
        form.setFieldsValue({
            company: companyId,
        });
        setFormState("view");
        setSalepersonAllId(null);
    };







    // Allowed file extensions base mapping
    const fileTypeAcceptMap = {
        pdf: ".pdf",
        image: ".jpg,.jpeg,.png,.webp",
        excel: ".xls,.xlsx,.csv",
        doc: ".doc,.docx",
    };


    const handleModalOpen = () => {
        setIsFileModalVisible(true);
    };

    const handleModalClose = () => {
        modalForm.resetFields();
        setFileList([]);
        setIsFileModalVisible(false);
    };

    const isValidFileType = (file, type) => {
        if (!type) return true;
        const fileName = file.name.toLowerCase();
        if (type === "pdf") return fileName.endsWith(".pdf");
        if (type === "image") return /\.(jpg|jpeg|png|webp)$/i.test(fileName);
        if (type === "excel") return /\.(xls|xlsx|csv)$/i.test(fileName);
        if (type === "doc") return /\.(doc|docx)$/i.test(fileName);
        return true;
    };


    const handleBeforeUpload = (file) => {
        if (!selectedFileType) {
            message.warning("Please select a File Type first!");
            return Upload.LIST_IGNORE; // File reject ho jayegi
        }

        const isValid = isValidFileType(file, selectedFileType);
        if (!isValid) {
            message.error(`Only ${selectedFileType.toUpperCase()} files are allowed!`);
            return Upload.LIST_IGNORE; // File reject ho jayegi
        }

        return false; // Prevent automatic HTTP upload, manual handle karein
    };

    const handleFileChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    const handleModalSubmit = async () => {
        try {
            const values = await modalForm.validateFields();

            if (!fileList.length) {
                Swal.fire({
                    icon: "warning",
                    title: "File Missing",
                    text: "Please select a file to upload.",
                    confirmButtonColor: "#3c4b58",
                });
                return;
            }

            setFileLoading(true);



            const payload = new FormData();
            payload.append("vendor_id", vendor_id);
            payload.append("file", fileList[0].originFileObj);
            payload.append("file_type", values.file_type);
            payload.append("upload_remarks", values.remarks);


            console.log("payload", payload)

            try {
                const response = await axios({
                    method: "POST",
                    url: `${BASEURL}uploads/vendorCommunication/1`,
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + token,
                    },
                    data: payload, // payload yahan FormData object hona chahiye
                });

                console.log("response", response)

                if (response.status === 200 || response.status === 201) {
                    // Success Notification
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: response.data?.message || "File uploaded successfully!",
                    });
                    setFileLoading(false);
                    setIsFileModalVisible(false);
                    modalForm.resetFields();
                    setFileList([]);
                    getAllFiles();
                    return response.data;
                }
            } catch (error) {


                // Error Alert Display
                Swal.fire({
                    icon: "error",
                    title: "Upload Failed",
                    text: "Something went wrong while uploading the file. Please try again.",
                });
                setFileLoading(false);

                // Re-throw or dispatch error state as needed
                throw error;
            }
        } catch (errorInfo) {
            console.log("Validation Failed:", errorInfo);
        }
    };


    const handleFileDelete = async (record) => {
        console.log("record", record)
        // setLoading(true);
        try {
            const response = await axios({
                method: "DELETE", // Ya backend API ke mutabiq "DELETE" / "PUT"
                url: `${BASEURL}delete/vendorCommunication/${record.vendor_communication_id}`,
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            if (response.status === 200 || response.data) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "File deleted successfully!",
                });
                // Fresh data load karne ke liye list refresh karein
                getAllFiles();
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to delete the file.",
            });
        } finally {
            // setLoading(false);
        }
    };

    const communicationColumns = [
        {
            title: "#",
            dataIndex: "index",
            key: "index",
            width: 60,
            render: (text, record, index) => index + 1,
        },
        {
            title: "File Name",
            dataIndex: "physical_file_name",
            key: "physical_file_name",
            sorter: (a, b) => a.physical_file_name?.localeCompare(b.physical_file_name),
        },
        {
            title: "Type",
            dataIndex: "upload_file_type",
            key: "upload_file_type",
            render: (type) => {
                let color = "blue";
                if (type === "excel") color = "green";
                else if (type === "pdf") color = "red";
                else if (type === "image") color = "purple";

                return (
                    <Tag color={color} style={{ textTransform: "uppercase" }}>
                        {type || "N/A"}
                    </Tag>
                );
            },
        },
        {
            title: "Remarks",
            dataIndex: "upload_remarks",
            key: "upload_remarks",
            render: (remarks) => remarks || "-",
        },
        {
            title: "Created Date",
            dataIndex: "created_date",
            key: "created_date",
            sorter: (a, b) => new Date(a.created_date) - new Date(b.created_date),
            render: (date) => (date ? moment(date).format("MM-DD-YYYY") : "-"),
        },
        // {
        //   title: "Status",
        //   dataIndex: "is_active",
        //   key: "is_active",
        //   render: (isActive) => (
        //     <Tag color={isActive ? "success" : "error"}>
        //       {isActive ? "Active" : "Inactive"}
        //     </Tag>
        //   ),
        // },
        {
            title: "Action",
            dataIndex: "upload_file_url",
            key: "upload_file_url",
            align: "center",
            render: (url, record) => (
                <Space size="middle">
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="View / Download File"
                    >
                        <Button type="primary" size="small" icon={<EyeOutlined />}>
                            View File
                        </Button>
                    </a>
                    <Tooltip title="Delete" color={"white"}>

                        <>
                            <Popconfirm
                                title={`Are you sure to delete the item ?`}
                                onConfirm={() => handleFileDelete(record)}
                            >
                                <DeleteOutlined className={`delete-Button`} />
                            </Popconfirm>

                        </>
                    </Tooltip>
                </Space>
            ),
        },
    ];



    const isEditable = formState === "add" || formState === "edit";

    // Modal Open Handler (Add New)
    const handleAddNew = () => {
        bankmodalForm.resetFields();
        setEditingIndex(null);
        setIsModalVisible(true);
    };

    // Modal Open Handler (Edit)
    const handleEdit = (record, index) => {
        console.log("record", record)
        bankmodalForm.setFieldsValue(record);
        setEditingIndex(index);
        setIsModalVisible(true);
    };

    // Delete Bank Account
    const handlebankDelete = (index) => {
        const deletedItem = bankList[index];

        if (deletedItem) {
            setBankListDeleted((prev) => [...prev, deletedItem]);
        }

        const updatedList = bankList.filter((_, i) => i !== index);
        setBankList(updatedList);

        message.success("Bank detail deleted successfully!");
    };

    // Save/Update Bank Detail in Local Array State
    const handlebankModalSubmit = (values) => {
        if (editingIndex !== null) {
            const updatedList = [...bankList];

            updatedList[editingIndex] = {
                ...bankList[editingIndex],
                ...values,
            };

            console.log("Updated record with ID:", updatedList[editingIndex]);
            setBankList(updatedList);
            message.success("Bank detail updated!");
        } else {
            // Add new record
            setBankList([...bankList, values]);
            message.success("Bank detail added!");
        }

        setIsModalVisible(false);
        bankmodalForm.resetFields();
    };

    // Table Columns Setup
    const billing_columns = [
        {
            title: "#",
            render: (_, __, index) => index + 1,
            width: 50,
        },
        {
            title: "Bank Name",
            dataIndex: "bank_name",
            key: "bank_name",
        },
        {
            title: "Account Holder",
            dataIndex: "beneficiary_account_holder_name",
            key: "beneficiary_account_holder_name",
        },
        {
            title: "Account Number",
            dataIndex: "bank_account_number",
            key: "bank_account_number",
        },
        {
            title: "SWIFT/BIC Code",
            dataIndex: "swift_bic_code",
            key: "swift_bic_code",
        },
        {
            title: "Routing Number",
            dataIndex: "routing_number",
            key: "routing_number",
        },
        {
            title: "Account Type",
            dataIndex: "account_type",
            key: "account_type",
        },
        {
            title: "Bank Address",
            dataIndex: "bank_address",
            key: "bank_address",
        },
        {
            title: "Beneficiary Address",
            dataIndex: "beneficiary_address",
            key: "beneficiary_address",
        },

        {
            title: "Actions",
            key: "actions",
            render: (_, record, index) => (
                <Space size="middle">
                    <EditOutlined
                        style={{ color: "#1677ff", cursor: isEditable ? "pointer" : "not-allowed" }}
                        onClick={() => isEditable && handleEdit(record, index)}
                    />
                    <Popconfirm
                        title="Are you sure you want to delete this bank account?"
                        onConfirm={() => handlebankDelete(index)}
                        okText="Yes"
                        cancelText="No"
                        disabled={!isEditable}
                    >
                        <DeleteOutlined
                            style={{ color: "red", cursor: isEditable ? "pointer" : "not-allowed" }}
                        />
                    </Popconfirm>
                </Space>
            ),
        },
    ];


    console.log("deletedBillItems", deletedBillItems)

    return (
        <>
            <div className="styleContainer">
                <div className="styleBody h-100">
                    <PageHeader
                        title={"Vendor"}
                        minimize={setMinimize}
                        check={minimize}
                    />
                    {!minimize && (
                        <div className="bodyStyle">
                            <div className="crudDiv">
                                <CrudButtons
                                    name={"vendor"}
                                    userRights={userRights?.payload}
                                    reset={filterReset}
                                    formType={formState}
                                    save={formSave}
                                    disable={disable}
                                    formState={setFormState}
                                    onDelete={handleDelete}
                                />
                            </div>

                            <SubTitle name={"Primary Information"} />
                            <div className="formProduct p-0">
                                {/* {formState === "edit" && (
                                    <div className="undoDiv">
                                        <Tooltip
                                            placement="left"
                                            title="Form Reset"
                                            color="#fbfbfb"
                                        >
                                            <Button
                                                className="iconBtn undoBtn "
                                                icon={<UndoOutlined />}
                                                shape="circle"
                                            />
                                        </Tooltip>
                                    </div>
                                )} */}

                                <Form onFinish={onFinish} form={form} name="basic">
                                    {loading && (
                                        <div className="loaderDiv">
                                            <Loader type="Grid" color="#212121" height={40} width={40} />
                                        </div>
                                    )}
                                    <div className="container-fluid pbpx-5 ptpx-5">
                                        <Brow>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="slc">
                                                    <Form.Item
                                                        name="company"
                                                        label="Company"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        initialValue={formState === "add" ? null : form.getFieldValue().company}
                                                    >
                                                        <Select
                                                            size='small'
                                                            showSearch
                                                            optionFilterProp="children"
                                                            onSearch={onSearch}
                                                            filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                            disabled={formState === "add" || formState === "edit" || formState === "view" || formState === "formView"}
                                                            className="styleInput w-100"
                                                        >
                                                            {companyAll?.payload?.data.map((item) => {
                                                                return (
                                                                    <Option
                                                                        key={item.company_id}
                                                                        value={item.company_id}
                                                                    >
                                                                        {item.company_name}
                                                                    </Option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div>
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="vendorID"
                                                            label="Vendor ID:"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().vendorID}
                                                        >
                                                            <Input
                                                                size='small'
                                                                className="styleInput"
                                                                // placeholder="Vendor ID"
                                                                disabled={formState === "add" || formState === "edit" || formState === "view" || formState === "formView"}
                                                                ref={vendorInput}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div>
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="vendorCode"
                                                            label="Vendor Code:"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().vendorCode}
                                                        >
                                                            <Input
                                                                size='small'
                                                                className="styleInput"
                                                                // placeholder="Vendor Code"
                                                                disabled={formState === "add" || formState === "edit" || formState === "view" || formState === "formView"}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="vendorName"
                                                            label="Vendor Name"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().vendorName}
                                                            rules={[{ required: true, message: "Name is required" }]}
                                                        >
                                                            <Input
                                                                className="styleInput"
                                                                size='small'
                                                                // placeholder="Vendor Name"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">

                                                        <Form.Item
                                                            name="vendorType"
                                                            label="Vendor Type"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().vendorType}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Name is required",
                                                                },
                                                            ]}
                                                        >
                                                            <Radio.Group onChange={onTypeChange} value={typeValue}>
                                                                <Radio value="I">Indivisual</Radio>
                                                                <Radio value="C">Company</Radio>

                                                            </Radio.Group>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="vendorCat"
                                                            label="Vendor Category"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().vendorCat}
                                                        >
                                                            <Select
                                                                size='small'
                                                                showSearch
                                                                optionFilterProp="children"
                                                                onSearch={onSearch}
                                                                filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                                className="styleInput w-100"
                                                            >
                                                                {vendorCategory?.payload?.data.map((item) => {
                                                                    return (
                                                                        <Option
                                                                            key={item.vendor_category_id}
                                                                            value={item.vendor_category_id}
                                                                        >
                                                                            {item.category_name}
                                                                        </Option>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </Form.Item>
                                                        {/* <Form.Item
                                                                name="vendorCat"
                                                                label="Vendor Category"
                                                                labelAlign="left"
                                                                labelCol={{ span: 8 }}
                                                                wrapperCol={{ span: 16 }}
                                                                initialValue={formState === "add" ? null : form.getFieldValue().vendorCat}
                                                                rules={[{ required: true, message: "Name is required" }]}
                                                            >
                                                                <Input
                                                                    className="styleInput"
                                                                    size='small'
                                                                    // placeholder="Name"
                                                                    disabled={!(formState === "add" || formState === "edit")}
                                                                />
                                                            </Form.Item> */}
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">

                                                        <Form.Item
                                                            name="webaddress"
                                                            label="web Address"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().webadd}
                                                        // rules={[{ required: true, message: "Name is required" }]}
                                                        >
                                                            <Input
                                                                className="styleInput"
                                                                size='small'
                                                                // placeholder="web Address"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">

                                                        <Form.Item
                                                            name="balance"
                                                            label="Balance"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().balance}
                                                        // rules={[{ required: true, message: "Name is required" }]}
                                                        >
                                                            <InputNumber
                                                                size='small'
                                                                className="styleInput"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">

                                                        <Form.Item
                                                            name="active"
                                                            label="Active"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().active}
                                                            rules={[{ required: true, message: "Name is required" }]}
                                                        >
                                                            <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)}  ></Checkbox>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Button
                                                style={{ display: "none" }}
                                                onClick={onFinish}
                                                ref={submitButton}
                                            />
                                        </Brow>
                                    </div>
                                </Form>
                            </div>

                            <SubTitle name={"Email | Phone | Address"} />

                            <div className="formProduct p-0">
                                {/* {formState === "edit" && (
                                    <div className="undoDiv">
                                        <Tooltip
                                            placement="left"
                                            title="Form Reset"
                                            color="#fbfbfb"
                                        >
                                            <Button
                                                className="iconBtn undoBtn "
                                                icon={<UndoOutlined />}
                                                shape="circle"
                                            />
                                        </Tooltip>
                                    </div>
                                )} */}

                                <Form onFinish={onFinish} form={form} name="basic">

                                    <div className="container-fluid pbpx-5 ptpx-5">
                                        <Brow>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="email"
                                                            label="Email"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().email}
                                                            rules={[{ type: "email", message: "EMAIL is not Valid" }]}
                                                        >
                                                            <Input size='small'
                                                                className="styleInput"
                                                                // placeholder="Email"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />

                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="officePhone"
                                                            label="Office Phone:"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().officePhone}
                                                            rules={[{ pattern: new RegExp(/^(?!0*[.,]0*$|[.,]0*$|0*$)\d+[,.]?\d{0,6}$/), message: "Must Be a Number." }]}
                                                        >
                                                            <Input
                                                                size='small'
                                                                className="styleInput"
                                                                // placeholder="office Phone"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="mobilePhone"
                                                            label="Mobile Phone:"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().mobilePhone}
                                                            rules={[{ pattern: new RegExp(/^(?!0*[.,]0*$|[.,]0*$|0*$)\d+[,.]?\d{0,6}$/), message: "Must Be a Number." }]}
                                                        >
                                                            <Input
                                                                size='small'
                                                                className="styleInput"
                                                                // placeholder="Mobile Phone"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="">
                                                    <div className="relative">
                                                        <Form.Item
                                                            name="fax"
                                                            label="Fax:"
                                                            labelAlign="left"
                                                            labelCol={{ span: 8 }}
                                                            wrapperCol={{ span: 16 }}
                                                            initialValue={formState === "add" ? null : form.getFieldValue().fax}
                                                        >
                                                            <Input size='small'
                                                                className="styleInput"
                                                                // placeholder="Fax"
                                                                disabled={!(formState === "add" || formState === "edit")}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Bcol>
                                            <Button
                                                style={{ display: "none" }}
                                                onClick={onFinish}
                                                ref={submitButton}
                                            />
                                        </Brow>
                                    </div>
                                </Form>
                            </div>

                            {/* <br /> */}
                            <Divider />
                            <div className="styleTab">
                                <Tabs
                                    size="small"
                                    type='card'
                                    tabBarGutter={1}
                                    defaultActiveKey="1"
                                    centered
                                    onChange={(key) => handleTab(key)}
                                >
                                    <TabPane tab="Billing" key="billing">
                                        <div className="tabs">
                                            <VendorBilling
                                                addressDataBill={setAddressDataBill}
                                                customer_id={customerID}
                                                vendor_id={vendor_id}
                                                formState={setFormState}
                                                formType={formState}
                                                token={token}
                                                deletedBillItems={deletedBillItems}
                                                setDeletedBillItems={setDeletedBillItems}
                                            />

                                        </div>
                                    </TabPane>
                                    <TabPane tab="Shipping" key="shipping">
                                        <div className="tabs">
                                            <VendorShipping
                                                addressDataShip={setAddressDataShip}
                                                formState={setFormState}
                                                customer_id={customerID}
                                                vendor_id={vendor_id}
                                                formType={formState}
                                                token={token}
                                                deletedShipItems={deletedShipItems}
                                                setDeletedShipItems={setDeletedShipItems}
                                            />
                                        </div>
                                    </TabPane>
                                    <TabPane tab="Bank Details" key="bank">
                                        <div className="tabs p-3">
                                            {/* Top Header with Add Button */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h6 className="m-0">Bank Accounts List</h6>
                                                {isEditable && (
                                                    <Button
                                                        type="primary"
                                                        icon={<PlusOutlined />}
                                                        onClick={handleAddNew}
                                                        size="small"
                                                    >
                                                        Add Bank Detail
                                                    </Button>
                                                )}
                                            </div>

                                            {/* Multiple Bank Accounts List Table */}
                                            <Table
                                                dataSource={bankList}
                                                columns={billing_columns}
                                                rowKey={(_, index) => index}
                                                pagination={false}
                                                size="small"
                                                bordered
                                                locale={{ emptyText: "No bank details added yet." }}
                                            />

                                            {/* Modal Form for Adding/Editing Bank Details */}
                                            <Modal
                                                title={editingIndex !== null ? "Edit Bank Detail" : "Add Bank Detail"}
                                                visible={isModalVisible}
                                                onCancel={() => setIsModalVisible(false)}
                                                onOk={() => bankmodalForm.submit()}
                                                okText={editingIndex !== null ? "Update" : "Save"}
                                                width={700}
                                                destroyOnClose
                                            >
                                                <Form
                                                    form={bankmodalForm}
                                                    onFinish={handlebankModalSubmit}
                                                    layout="vertical"
                                                    name="bankModalForm"
                                                >
                                                    <Brow>
                                                        <Bcol lg={6}>
                                                            <Form.Item
                                                                name="bank_name"
                                                                label="Bank Name"
                                                                rules={[{ required: true, message: "Please enter Bank Name" }]}
                                                            >
                                                                <Input size="small" placeholder="Enter Bank Name" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={6}>
                                                            <Form.Item
                                                                name="beneficiary_account_holder_name"
                                                                label="Account Holder Name"
                                                                rules={[{ required: true, message: "Please enter Holder Name" }]}
                                                            >
                                                                <Input size="small" placeholder="Account Holder Name" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={6}>
                                                            <Form.Item
                                                                name="bank_account_number"
                                                                label="Bank Account Number"
                                                                rules={[{ required: true, message: "Please enter Account Number" }]}
                                                            >
                                                                <Input size="small" placeholder="Account Number" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={6}>
                                                            <Form.Item name="account_type" label="Account Type">
                                                                <Input size="small" placeholder="e.g. Checking / Savings" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={6}>
                                                            <Form.Item name="swift_bic_code" label="SWIFT/BIC Code">
                                                                <Input size="small" placeholder="SWIFT/BIC Code" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={6}>
                                                            <Form.Item name="routing_number" label="Routing Number">
                                                                <Input size="small" placeholder="Routing Number" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={12}>
                                                            <Form.Item name="bank_address" label="Bank Address">
                                                                <Input size="small" placeholder="Bank Branch Address" />
                                                            </Form.Item>
                                                        </Bcol>
                                                        <Bcol lg={12}>
                                                            <Form.Item name="beneficiary_address" label="Beneficiary Address">
                                                                <Input size="small" placeholder="Beneficiary Address" />
                                                            </Form.Item>
                                                        </Bcol>
                                                    </Brow>
                                                </Form>
                                            </Modal>
                                        </div>
                                    </TabPane>
                                    <TabPane tab="Communication" key="communication">
                                        <Collapse defaultActiveKey={["1"]}>
                                            <div className="p-3">
                                                <Button
                                                    type="primary"
                                                    className="modalButton"
                                                    onClick={handleModalOpen}
                                                    disabled={!(formState === "edit")}
                                                >
                                                    Upload File
                                                </Button>
                                            </div>
                                        </Collapse>
                                        {
                                            communucationFile.length > 0 && (
                                                <Table
                                                    type={"company"}
                                                    // loading={expenseBill.loading}
                                                    scroll={({ x: 600 }, { y: 400 })}
                                                    size="small"
                                                    bordered
                                                    dataSource={JSON.parse(JSON.stringify(communucationFile))}
                                                    columns={communicationColumns}
                                                    pagination={false}
                                                />
                                            )
                                        }
                                        {/* Upload Modal */}
                                        <Modal
                                            title="Upload Communication File"
                                            visible={isFileModalVisible}
                                            onCancel={handleModalClose}
                                            footer={[
                                                <Button key="back" onClick={handleModalClose}>
                                                    Cancel
                                                </Button>,
                                                <Button
                                                    key="submit"
                                                    type="primary"
                                                    loading={fileloading}
                                                    onClick={handleModalSubmit}
                                                >
                                                    Upload
                                                </Button>,
                                            ]}
                                        >
                                            <Form form={modalForm} layout="vertical" name="modal_upload_form"
                                                onValuesChange={(changedValues) => {
                                                    if (changedValues.file_type !== undefined) {
                                                        setSelectedFileType(changedValues.file_type);
                                                    }
                                                }}
                                            >
                                                {/* File Type Dropdown */}
                                                <Form.Item
                                                    name="file_type"
                                                    label="File Type"
                                                    rules={[{ required: true, message: "Please select file type" }]}
                                                >
                                                    <Select placeholder="Select File Type" allowClear>
                                                        <Option value="pdf">PDF Document (.pdf)</Option>
                                                        <Option value="image">Image (.png, .jpg, .jpeg)</Option>
                                                        <Option value="excel">Excel Spreadsheet (.xlsx, .xls, .csv)</Option>
                                                        <Option value="doc">Word Document (.doc, .docx)</Option>
                                                    </Select>
                                                </Form.Item>

                                                {/* File Attachment Control */}
                                                <Form.Item
                                                    name="file"
                                                    label="Select File"
                                                    rules={[{ required: true, message: "Please attach a file" }]}
                                                >
                                                    <Upload
                                                        beforeUpload={handleBeforeUpload}
                                                        fileList={fileList}
                                                        onChange={handleFileChange}
                                                        maxCount={1}
                                                        accept={fileTypeAcceptMap[selectedFileType] || "*"}
                                                    >
                                                        <Button icon={<UploadOutlined />}>Select Attachment</Button>
                                                    </Upload>
                                                </Form.Item>

                                                {/* Remarks Field */}
                                                <Form.Item
                                                    name="remarks"
                                                    label="Remarks"
                                                    rules={[{ required: false }]}
                                                >
                                                    <TextArea
                                                        rows={3}
                                                        placeholder="Enter file upload remarks or notes..."
                                                    />
                                                </Form.Item>
                                            </Form>
                                        </Modal>
                                    </TabPane>
                                    {(formState === "edit" || formState === "formView") && (
                                        <TabPane tab="System Information" key="logs">
                                            <div className="tabs">
                                                {systemLog?.payload?.data?.length > 0 && (
                                                    <Tables
                                                        type="company"
                                                        scrollX={"50rem"}
                                                        scroll={360}
                                                        perPage={15}
                                                        source={systemLog?.payload?.data}
                                                        dataSource={[]}
                                                        col={renderColumns()}
                                                        load={systemLog?.loading}
                                                        paginate
                                                    />
                                                )}
                                            </div>
                                        </TabPane>
                                    )}
                                </Tabs>
                            </div>

                        </div>
                    )}
                </div>
                {minimize && (
                    <div className="CustomerFooter">
                        <Button
                            className='minimize-button-style'
                            onClick={() => setMinimize(false)}
                        >
                            SalePerson
                        </Button>
                    </div>
                )}
            </div>

        </>
    );
}
